module.exports = __webpack_public_path__ + "img/2017.b80ad79c.svg";